<template>
  <div id="section-5" class="section-5">
    <div class="info">
      <div class="content">
        <div style="display: flex; align-items: center;">
          <span class="DINPro-Regular year"
            >Copyright {{ new Date().getFullYear() }}</span
          >&nbsp;&nbsp;beat365-官方手机版网站-Official website版权所有&nbsp;&nbsp;<a
            href="https://beian.miit.gov.cn/ "
            rel="“nofollow”"
            target="_blank"
            >京ICP备<span class="DINPro-Regular">{{ beianInfo.icp }}</span><span
              class="DINPro-Regular"
            ></span></a
          >&nbsp;&nbsp;
          <img class="icon-gov" src="https://datahub.haohuan.com/gfs/2024-03/58f55c5c8e4301344d9c5fb4a98075c1-8.png">
          <a
            :href=govLink
            rel="noreferrer"
            target="_blank"
            >京公网安备<span class="DINPro-Regular">{{ beianInfo.gov }}</span></a
          >&nbsp;&nbsp;<a
            href="https://api-m.we.cn/landingPage/page?code=WC_License"
            target="_blank"
            >营业执照</a>
            &nbsp;&nbsp;
          <a v-if="beianInfo.secUrl" :href="beianInfo.secUrl" target="_blank" style="position: relative;display: inline-block;height: 38px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed :src="beianInfo.secIcon" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a>
          </div>
        <p>客服/投诉热线：<span class="DINPro-Regular">{{ phoneConfig.join('或') }}</span></p>
        <p>媒体采访：<span class="DINPro-Regular">pr<span class="font-normal">@</span>we.cn</span></p>
        <div class="tip">
          市场有风险，借贷需谨慎<br />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getStaticConfig } from '@/api/home';

const originInfo = {
  'wcsk.cn': {
    icp: '12052273号-16',
    gov: '',
    sn:''
  },
  'weicaitech.cn': {
    icp: '12052273号-13',
    gov: '11010502053034',
    sn:'1782355220341116928'
  },
  'weicaitech.com': {
    icp: '12052273号-12',
    gov: '11010502053035',
    sn:'1782355158185725952'
  },
  'we.cn': {
    icp: '12052273号-9',
    gov: '11010502042426',
    sn:'1795040066452529152'

  },
  'weicai.com.cn': {
    icp: '12052273号-8',
    gov: '11010502042200',
    sn:'1795039919404425216'
  }
}
export default {
  data() {
    return {
      phoneConfig: []
    }
  },
  mounted() {
      window.scrollTo(0, 0);
      getStaticConfig().then(res => {
        this.phoneConfig = (res.data.customerPhone || {}).phone || [];
      })
  },
  computed: {
    beianInfo() { // 备案信息
      try {
        const info = originInfo[location.host.replace('www.', '')];
        if (info && info.sn) {
          info.secUrl = `https://xyt.xcc.cn/getpcInfo?sn=${info.sn}&language=CN&certType=8&url=${location.host}`;
          info.secIcon = `https://program.xinchacha.com/web/${info.sn}=${location.host}.svg`;
        }
        return info ? info : {
          icp: '12052273号',
          gov: '11010502042426',
          secUrl: 'https://xyt.xcc.cn/getpcInfo?sn=1782355158185725952&language=CN&certType=8&url=www.weicaitech.com',
          secIcon: 'https://program.xinchacha.com/web/1782355158185725952=www.weicaitech.com.svg'
        }
      } catch (error) {
        return {
          icp: '12052273号',
          gov: '11010502042426'
        }
      }
    },
    govLink() {
      return `https://beian.mps.gov.cn/#/query/webSearch?code=${this.beianInfo.gov}`
    }
  }
}
</script>

<style lang="less" scoped>
.section-5 {
  margin-bottom: 0;
  background: #000000;
  color: #fff;
  font-size: 14px;
  height: 180px !important;
  box-sizing: border-box;
  padding-top: 39px;
  .info {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    width: 1080px;
  }
  .content {
    // margin: 0 auto;
    p{
      line-height: 1.8;
    }
  }
  .tip {
    font-size: 14px;
    // text-align: right;
    opacity: 0.5;
    line-height: 1.8;
  }
  a {
    color: #fff;
  }
}
.font-normal{
  font-family: none;
}
.icon-gov {
  width: 16px;
  height: 17px;
  vertical-align: text-top;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue